// API 配置
const API_CONFIG = {
  // 基础API地址
  BASE_URL: 'https://qcpro.xxdazz.com/prod-api',
  // BASE_URL: 'http://127.0.0.1:9055',
  // 本地程序版本（每次打包前手动调整）
  APP_VERSION_CODE: 1001,
  APP_VERSION_NAME: 'v2.1.0',
  
  // API端点
  ENDPOINTS: {
    LOGIN: '/card/card/api/login',
    BUTTON_PERMISSION_LIST: '/card/permission/api/list',
    BUTTON_PERMISSION_SAVE: '/card/permission/api/save',
    SHOP_LIST: '/qianchuan/info/api/shopList',
    GET_ACCESS_TOKEN_BY_CODE: '/qianchuan/info/getAccessTokenByCode',
    UPLOAD_VIDEO: 'https://ad.oceanengine.com/open_api/2/file/video/ad/',
    MATERIAL: '/qianchuan/info/api/material',
    MATERIALS: '/qianchuan/info/api/materials',
    MATERIAL_SHARE: '/qianchuan/info/api/materialShare',
    MATERIAL_SHARE_TIMER: '/qianchuan/info/api/materialShareTimer',
    VIDEO_MATERIAL_ID: '/qianchuan/info/api/video/materialId',
    WALLET: '/qianchuan/info/api/wallet',
    WALLET_LIST: '/qianchuan/info/api/wallet/list',
    JOB_LIST: '/qianchuan/info/api/job/list',
    JOB_MATERIAL_THRESHOLD: '/qianchuan/info/api/job/materialThreshold',
    DEL_SHOP: '/qianchuan/info/api/delShop',
    SMART_BOOST_SWITCH: '/qianchuan/info/api/controlTask/smartBoostSwitch',
  },
  
  // 获取完整API URL
  getFullUrl: function(endpoint) {
    return this.BASE_URL + endpoint;
  },
  
  // 获取登录API URL
  getLoginUrl: function() {
    return this.getFullUrl(this.ENDPOINTS.LOGIN);
  },
  getAppVersionCode: function() {
    return Number(this.APP_VERSION_CODE || 0)
  },
  getAppVersionName: function() {
    return String(this.APP_VERSION_NAME || '')
  },
  
  // 获取店铺列表API URL
  getShopListUrl: function() {
    return this.getFullUrl(this.ENDPOINTS.SHOP_LIST);
  },
  getButtonPermissionListUrl: function() {
    return this.getFullUrl(this.ENDPOINTS.BUTTON_PERMISSION_LIST);
  },
  saveButtonPermissionUrl: function() {
    return this.getFullUrl(this.ENDPOINTS.BUTTON_PERMISSION_SAVE);
  },
  
  // 获取accessToken API URL
  getAccessTokenByCodeUrl: function() {
    return this.getFullUrl(this.ENDPOINTS.GET_ACCESS_TOKEN_BY_CODE);
  },

    // 添加全域投放计划下素材
  addMaterial: function() {
    return this.getFullUrl(this.ENDPOINTS.MATERIAL);
  },
  
    // 批量添加全域投放计划下素材
  addMaterials: function() {
    return this.getFullUrl(this.ENDPOINTS.MATERIALS);
  },
  materialShare: function() {
    return this.getFullUrl(this.ENDPOINTS.MATERIAL_SHARE);
  },
  materialShareTimer: function() {
    return this.getFullUrl(this.ENDPOINTS.MATERIAL_SHARE_TIMER);
  },
  videoMaterialId: function() {
    return this.getFullUrl(this.ENDPOINTS.VIDEO_MATERIAL_ID);
  },
  wallet: function() {
    return this.getFullUrl(this.ENDPOINTS.WALLET);
  },
  walletList: function() {
    return this.getFullUrl(this.ENDPOINTS.WALLET_LIST);
  },
  jobList: function() {
    return this.getFullUrl(this.ENDPOINTS.JOB_LIST);
  },
  jobMaterialThreshold: function() {
    return this.getFullUrl(this.ENDPOINTS.JOB_MATERIAL_THRESHOLD);
  },
  delShop: function() {
    return this.getFullUrl(this.ENDPOINTS.DEL_SHOP);
  },
  smartBoostSwitch: function() {
    return this.getFullUrl(this.ENDPOINTS.SMART_BOOST_SWITCH);
  },
  // 获取上传视频API URL
  getUploadVideoUrl: function() {
    return this.ENDPOINTS.UPLOAD_VIDEO;
  }
};

// 导出配置
export default API_CONFIG;
